import { useQuery } from 'react-query';
import { userStore } from '@/store/users';
import { axiosClient } from '@/services/utilities';

const getUserProfile = async () => {
  const { data } = await axiosClient.get(`/users/profile/active`);
  const subject = `net.mainapi:users:${data.username}`;
  const action = 'net.mainapi:actions:login';
  const objectAdmin = 'net.mainapi:services:admin-portal';
  const objectPublisher = 'net.mainapi:services:publisher-portal';
  const { data: isUserAdmin } = await axiosClient.get(
    `/police?subject=${subject}&action=${action}&object=${objectAdmin}`,
  );

  const { data: isUserPublisher } = await axiosClient.get(
    `/police?subject=${subject}&action=${action}&object=${objectPublisher}`,
  );
  const mappedUser = {
    ...data,
    isAdmin: isUserAdmin.length > 0,
    isPublisher: isUserPublisher.length > 0,
  };

  return mappedUser;
};

export const useUserProfile = () => {
  const [, setUserLogedIn] = userStore((state) => [
    state.userLogedIn,
    state.setUserLogedIn,
  ]);
  const { isSuccess, isError, isLoading } = useQuery({
    queryKey: ['users', 'profile'],
    queryFn: getUserProfile,
    onSuccess: (data) => {
      setUserLogedIn(data);
    },
  });

  return { isSuccess, isError, isLoading };
};
